module.exports = __webpack_public_path__ + "img/logocolor.4598d0cb.svg";